(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(35970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O_": function() { return /* reexport safe */ _useIsClient__WEBPACK_IMPORTED_MODULE_2__.O; },
/* harmony export */   "f5": function() { return /* reexport safe */ _useEventLogs__WEBPACK_IMPORTED_MODULE_5__.f; }
/* harmony export */ });
/* harmony import */ var _useDebounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97486);
/* harmony import */ var _useFPTRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95249);
/* harmony import */ var _useIsClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17237);
/* harmony import */ var _useNFTMetadata__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56647);
/* harmony import */ var _useWalletNFTs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28372);
/* harmony import */ var _useEventLogs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27462);








/***/ }),

/***/ 35970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8395);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80419);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39653);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48641);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_wrap_balancer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41782);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38793);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44868);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46230);







const Home = ()=>{
    const isClient = (0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useIsClient */ .O_)();
    const { isConnected  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useAccount */ .mA)();
    const patentTextColor = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .useColorModeValue */ .ff)("slate.600", "slate.400");
    const patentLinkColor = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .useColorModeValue */ .ff)("brand.700", "brand.300");
    const toast = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .useToast */ .pm)({
        variant: "subtle",
        isClosable: true,
        position: "top-right"
    });
    const [selectedTokenSend, setselectedTokenSend] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [selectedTokenRetrieve, setselectedTokenRetrieve] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [selectedBulkTokens, setselectedBulkTokens] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const { isOpen: isBulkRetrieveOpen , onOpen: openBulkRetrieve , onClose: closeBulkRetrieve  } = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .useDisclosure */ .qY)();
    const { isOpen: isBulkSendToLoginOpen , onOpen: openBulkSendToLogin , onClose: closeBulkSendToLogin  } = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .useDisclosure */ .qY)();
    const onClickRetrieve = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((selectedToken)=>{
        setselectedTokenRetrieve(selectedToken);
    }, []);
    const onClickSend = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((selectedToken)=>{
        setselectedTokenSend(selectedToken);
    }, []);
    const onClickBulkSend = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        openBulkSendToLogin();
    }, [
        openBulkSendToLogin
    ]);
    const onClickBulkRetrieve = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        openBulkRetrieve();
    }, [
        openBulkRetrieve
    ]);
    const onSelectBulkTokens = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((selectedToken)=>{
        if (!selectedBulkTokens) {
            return setselectedBulkTokens({
                ...selectedToken,
                tokens: [
                    {
                        tokenId: selectedToken.tokenId,
                        parsedURI: selectedToken.parsedURI
                    }
                ]
            });
        }
        if ((selectedBulkTokens === null || selectedBulkTokens === void 0 ? void 0 : selectedBulkTokens.collection) !== selectedToken.collection) {
            return toast({
                title: "Error",
                description: "You can't select tokens from different collections",
                status: "error"
            });
        }
        if ((selectedBulkTokens === null || selectedBulkTokens === void 0 ? void 0 : selectedBulkTokens.status) !== selectedToken.status) {
            return toast({
                title: "Error",
                description: "You can't select tokens with different statuses",
                status: "error"
            });
        }
        if (selectedBulkTokens.tokens.find((param)=>{
            let { tokenId  } = param;
            return tokenId === selectedToken.tokenId;
        })) {
            return setselectedBulkTokens((prev)=>{
                if (!prev) return null;
                const tokens = prev.tokens.filter((param)=>{
                    let { tokenId  } = param;
                    return Number(tokenId) !== selectedToken.tokenId;
                });
                if (tokens.length === 0) return null;
                return {
                    ...selectedToken,
                    tokens
                };
            });
        }
        return setselectedBulkTokens((prev)=>{
            if (!prev) return null;
            return {
                ...prev,
                tokens: [
                    ...prev.tokens,
                    {
                        tokenId: selectedToken.tokenId,
                        parsedURI: selectedToken.parsedURI
                    }
                ]
            };
        });
    }, [
        selectedBulkTokens,
        toast
    ]);
    if (!isConnected && isClient) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .ConnectWallet */ .RZ, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .SendToLoginDialogue */ .zT, {
                selectedToken: selectedTokenSend,
                onClose: ()=>setselectedTokenSend(null)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .RetrieveDialogue */ .aK, {
                selectedToken: selectedTokenRetrieve,
                onClose: ()=>setselectedTokenRetrieve(null)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .BulkSendToLoginDialogue */ .l$, {
                selectedTokens: selectedBulkTokens,
                onSelectBulkTokens: onSelectBulkTokens,
                isOpen: isBulkSendToLoginOpen,
                onClose: ()=>closeBulkSendToLogin()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .BulkRetrieveDialogue */ .o1, {
                selectedTokens: selectedBulkTokens,
                onSelectBulkTokens: onSelectBulkTokens,
                isOpen: isBulkRetrieveOpen,
                onClose: ()=>closeBulkRetrieve()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, {
                w: "full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .kC, {
                        textAlign: "center",
                        flexDir: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        my: "12",
                        mx: "auto",
                        maxW: "xl",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Heading */ .X6, {
                                mt: "8",
                                zIndex: "1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_wrap_balancer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    children: "FoolProof Token Dashboard"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .xv, {
                                mt: "3",
                                zIndex: "1",
                                color: "slate.600",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_wrap_balancer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    children: "FoolProof Token (FPT) offers unparalleled security and control over digital assets by creating a 1:1 linked token to prove ownership without risking ownership."
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .xv, {
                                fontSize: "xs",
                                color: patentTextColor,
                                mt: "2",
                                zIndex: "1",
                                children: [
                                    "Protected by",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .rU, {
                                        href: "/patents",
                                        color: patentLinkColor,
                                        textDecoration: "none",
                                        _hover: {
                                            textDecoration: "underline"
                                        },
                                        children: "U.S. Patent No. 12,293,358"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W2, {
                        my: {
                            base: 8,
                            md: 12
                        },
                        p: {
                            base: 4,
                            md: 12
                        },
                        maxW: "4xl",
                        rounded: "md",
                        w: "full",
                        marginX: "auto",
                        borderWidth: {
                            base: 0,
                            md: 1
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .ShadowCollections */ .bz, {
                            onClickRetrieve: onClickRetrieve,
                            onClickSend: onClickSend,
                            onClickBulkRetrieve: onClickBulkRetrieve,
                            onSelectBulkTokens: onSelectBulkTokens,
                            onClickBulkSend: onClickBulkSend,
                            selectedBulkTokens: selectedBulkTokens
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);